module.exports = __webpack_public_path__ + "static/silence-2e5bf17b99cee7d1d3f09a40ff1e28cc.mp3";